<template>
  <div>
    <header-shared />
    <div class="conteudo-post">
      <post-loading v-if="loading" />
      <div class="post" v-if="!loading && materia">
        <div class="titulo">
          <h1>{{ materia.titulo }}</h1>
          <span>
            <strong>Postado em</strong>
            {{ materia.data_publicacao }} às {{ materia.hora_publicacao }}
          </span>
        </div>
        <!-- <div class="destaque"> -->
        <!-- <button class="botao-aceito">CONFIRMAÇÃO DE LEITURA</button> -->
        <!-- <img v-if="materia.lg || materia.md" :src="showImagePost(materia)"> -->
        <!-- <h5>{{materia.imagem_titulo}}</h5> -->
        <!-- </div> -->
        <div class="postagem" v-html="materia.conteudo"></div>
        <div class="rodape">
          <ul v-if="materia && materia.tags">
            <li v-for="(tag, indice) in materia.tags.data" :key="indice">
              <a href="javascript:void(0)">{{ tag.descricao | capitalize }}</a>
            </li>
          </ul>
        </div>
        <ModalCopy />
      </div>
      <error-404 v-if="!loading && materia === undefined">
        Matéria não disponível para
        o seu <strong>perfil</strong>.
      </error-404>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import env from '@/config/env';
import SharedNoticiaTemp from '@/graphql/queries/SharedNoticiaTemp.gql';
import HeaderShared from '@/components/layout/shared/Header.vue';
import PostLoading from '@/components/Loading/PostLoading';
import Error404 from '@/components/layout/error/404';
import ModalCopy from '@/components/ui/ModalCopy.vue';

export default {
  name: 'Shared',
  components: {
    HeaderShared,
    PostLoading,
    Error404,
    ModalCopy,
  },
  data: () => ({
    loading: false,
    materia: {},
  }),
  computed: {
    ...mapGetters({
      showModalCopy: "modalCopyStore/modalShow",
    }),
  },
  methods: {
    ...mapActions({
      openModalCopy: "modalCopyStore/show",
      closeModalCopy: "modalCopyStore/hide",
    }),
    tagCopyOpenModalEvent() {
      const self = this;

      return function(event) {
        event.preventDefault();
        event.stopPropagation();

        self.openModalCopy(this.innerText);
      };
    },
    createCopyIcon() {
      return function() {
        const iconId = 'fast-copy-icon-' + Date.now();

        const icon = document.createElement('span');

        icon.id = iconId;
        icon.style.width = '25px';
        icon.style.height = '25px';
        icon.style.display = 'inline-block';
        icon.style.backgroundRepeat = 'no-repeat';
        icon.style.backgroundSize = '25px 25px';
        icon.style.backgroundColor = 'white';
        icon.style.position = 'absolute';
        icon.style.backgroundImage = 'url("data:image/png;base64,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")';

        this.dataset.iconId = iconId;

        this.appendChild(icon);
      };
    },

    destroyCopyIcon() {
      return function() {
        document.getElementById(this.dataset.iconId).remove();

        delete this.dataset.iconId;
      };
    },

    updateFastCopyEvents() {
      const tags = [...document.getElementsByTagName('COPY')];

      tags
        .filter(tag => tag.dataset.event !== '1')
        .forEach(tag => {
          tag.addEventListener('click', this.tagCopyOpenModalEvent());

          // hover event
          tag.addEventListener('mouseover', this.createCopyIcon());
          tag.addEventListener('mouseout', this.destroyCopyIcon());
          tag.dataset.event = '1';
        });
    },
  },

  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27 && this.showModalCopy) {
        this.closeModalCopy();
      }
    });
  },

  updated() {
    this.updateFastCopyEvents();
  },

  async beforeMount() {
    this.loading = true;
    const { token } = this.$route.params;
    const query = await env.apolloNoticiaTemp.query({
      query: SharedNoticiaTemp,
      variables: {
        token,
      },
    });

    try {
      const { noticia } = query.data;
      this.materia = noticia;
      this.loading = false;
    } catch (e) {
      console.log(e);
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.conteudo-post {
  @extend %flex;
  @extend %direction-row;
  @extend %justify-center;
  @extend %flex-wrap;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0 auto;
  position: relative;
  // min-height: calc(100vh - 482px);

  & .post {
    width: 980px;

    & .titulo {
      margin-bottom: 10px;

      & h1 {
        color: $cor_roxo;
        font-family: 'Trebuchet MS', Helvetica, sans-serif;
        font-family: 'VivoType';
        font-weight: bold;
        font-size: 53px;
        margin: 0px;
        padding-bottom: 10px;
      }

      & span {
        font-family: 'OpenSans';
        color: $cor_cinza_dark;
        font-size: 14px;
        // text-transform: uppercase;
        // font-style: italic;
      }
    }

    & /deep/ .postagem {
      font-family: 'OpenSans';
      max-width: 100%;
      margin: 50px 0px;

      & * {
        font-size: 100%;
        color: $cor_cinza_dark;
        text-align: justify;
        margin: 0px;
        word-break: break-word;
        overflow-wrap: break-word;
        line-height: 1.5em;
        max-width: 980px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
      }

      & div {
        max-width: 100%;
        margin-right: 0px !important;
        margin-left: 0px !important;
        padding-right: 0px !important;
        padding-left: 0px !important;
      }

      & s {
        color: $cor_cinza_40;
      }

      & a {
        color: $cor_roxo;
      }

      & p {
        line-height: 1.7em;
      }

      & blockquote {
        border-left: 2px solid $cor_cinza_medium;
        color: $cor_cinza;
        padding-left: 40px !important;
        font-style: italic;
        font-size: 18px;
        margin: 20px 0px;

        &::before {
          content: '"';
        }

        &::after {
          content: '"';
        }
      }

      & iframe {
        max-width: 100%;
        min-width: 10% !important;
        margin: 20px 0;
        // box-shadow: 0 10px 30px rgba(0,0,0,.4);
        background: $cor_cinza_dark;
      }

      & h1 {
        font-weight: 600;
        font-size: 28px;
        & span {
          font-weight: 600;
          font-size: 28px;
        }
      }

      & h2 {
        font-weight: 600;
        font-size: 23px;
        & span {
          font-weight: 600;
          font-size: 23px;
        }
      }

      & h3 {
        font-weight: 600;
        font-size: 20px;
        & span {
          font-weight: 600;
          font-size: 20px;
        }
      }

      & h4 {
        font-weight: 600;
        font-size: 17px;
        & span {
          font-weight: 600;
          font-size: 17px;
        }
      }

      & h6 {
        font-weight: 600;
        font-size: 13px;
        & span {
          font-weight: 600;
          font-size: 13px;
        }
      }

      & img {
        border-radius: 5px;
        // max-width: 980px;
        // max-height: 980px;
        // box-shadow: 0 10px 30px rgba(0,0,0,.4)
      }

      & strong {
        font-weight: 600;
      }

      & ul,
      ol {
        padding-inline-start: 20px !important;
      }

      & ul > li {
        list-style-type: disc !important;
      }

      & ol > li {
        list-style-type: decimal !important;
      }

      & table {
        max-width: 100%;
      }

      & tr:nth-child(odd) {
        background: #eaeaea;
      }

      & tr:nth-child(1) {
        background: $cor_roxo;

        & td {
          color: #fff;
          font-weight: 600;
        }
      }

      & td {
        border-right: 0px solid white;
      }

      & tr {
        & td {
          padding: 5px 10px !important;
        }
      }

      copy {
        cursor: pointer !important;
        font-size: inherit !important;
        font-family: inherit !important;
        color: inherit !important;
        text-align: inherit !important;

        &:hover {
          background-color: #ff574b;
          color: white !important;
        }
      }
    }

    & .destaque {
      position: relative;
      min-width: 100%;
      max-width: 100%;
      height: auto;
      border-radius: 5px;
      box-sizing: border-box;

      & h5 {
        margin: 0px 0px 5px;
        font-weight: 500;
        letter-spacing: 0.02em;
        font-style: italic;
        color: $cor_cinza_100;
      }

      // & .botao-aceito {
      //   cursor: pointer;
      //   max-width: 100px;
      //   border-radius: 10px;
      //   padding: 10px;
      //   color: white;
      //   font-family: "Trebuchet MS", Helvetica, sans-serif;
      //   font-family: "Officina";
      //   font-weight: bold;
      //   letter-spacing: 0.02vmax;
      //   font-size: 16px;
      //   position: absolute;
      //   border: 3px solid $cor_cinza_10;
      //   background-color: $cor_vivo_azul;
      //   margin-top: -28px;
      //   margin-right: 20px;
      //   top: 0;
      //   right: 0;
      //   outline: none;

      //   &:hover {
      //     background-color: $cor_vivo_verde;
      //     // -webkit-box-shadow: 0px 5px 15px 1px rgba(46,205,80, 0.35);
      //     // -moz-box-shadow: 0px 5px 15px 1px rgba(46,205,80, 0.35);
      //     // box-shadow: 0px 5px 15px 1px rgba(46,205,80, 0.35);
      //   }
      // }

      & img {
        transition: 0.5s ease;
        object-fit: cover;
        // width: 100%;
        // height: 450px;
        border-radius: 5px;
        z-index: 1;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
      }
    }
    & .rodape {
      @extend %flex;
      @extend %direction-row;
      @extend %align-items-center;
      @extend %justify-between;
      width: 100%;
      margin: 50px 0px;

      & .botao-aceito {
        @extend %nao-selecionavel;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        position: relative;
        border-radius: 10px;
        padding: 20px 30px;
        margin-right: 20px;
        color: white;
        font-family: 'Trebuchet MS', Helvetica, sans-serif;
        font-family: 'VivoType';
        font-weight: bold;
        letter-spacing: 0.02vmax;
        font-size: 18px;
        border: 0px;
        background-color: $cor_azul_medium;
        outline: none;

        & p {
          position: relative;
          margin: 0px;
          z-index: 2;
        }

        & span {
          position: absolute;
          top: 50%;
          left: 50%;
          background-color: $cor_azul_medium;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          z-index: 1;
          transform: translate(-50%, -50%);
          animation: pulse 5s infinite ease-in-out;
        }

        &:hover {
          background-color: $cor_vivo_verde;
          -webkit-box-shadow: 0px 5px 15px 1px rgba(46, 205, 80, 0.35);
          -moz-box-shadow: 0px 5px 15px 1px rgba(46, 205, 80, 0.35);
          box-shadow: 0px 5px 15px 1px rgba(46, 205, 80, 0.35);

          & span {
            background: transparent;
            animation: none;
          }
        }

        &:disabled {
          pointer-events: none;
          background-color: transparent;
          padding: 0px;
          font-size: 18px;
          color: $cor_cinza;
          text-align: left;
          line-height: 18px;

          & div {
            margin-left: 15px;

            & .aceito_data {
              font-family: 'OpenSans';
            }
          }

          & img {
            width: 40px;
            height: auto;
          }
        }
      }

      // TAGS COM BOTAO DE CONFIRMAÇÃO DE LEITURA
      // & ul {
      //   @extend %flex;
      //   @extend %direction-row;
      //   @extend %flex-wrap;
      //   @extend %justify-end;
      //   margin: 0px;
      //   padding: 0px;
      //   max-width: 70%;

      //   & li {
      //     font-size: 14px;
      //     padding-left: 10px;
      //     margin: 0px;

      //     & a {
      //       text-decoration: none;
      //       color: $cor_cinza_40;

      //       &:hover {
      //         color: $cor_primaria;
      //       }
      //     }
      //   }
      // }

      & ul {
        @extend %flex;
        @extend %direction-row;
        @extend %flex-wrap;
        @extend %justify-start;
        margin: 0px;
        padding: 0px;
        max-width: 100%;

        & li {
          font-size: 14px;
          padding-right: 5px;
          margin: 0px;
          margin-bottom: 10px;

          & a {
            text-decoration: none;
            color: $cor_cinza;
            background: $cor_cinza_medium;
            padding: 2px 8px;
            border-radius: 5px;

            &:hover {
              color: white;
              background: $cor_roxo;
            }
          }
        }
      }
    }
  }
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 1;
  }
  40% {
    transform: translate(-50%, -50%) scale(1.3);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .conteudo-post {
    // overflow: hidden;

    & .post {
      width: 80vw;

      & .titulo {
        & h1 {
          font-size: calc((((100vw + 100vh) * 2) / 170) + 12px);
          padding-bottom: 1%;
        }

        & span {
          font-size: calc((((100vw + 100vh) * 2) / 400) + 4px);
        }
      }

      & /deep/ .postagem {
        overflow: hidden;
        margin: 0px;
        margin-top: calc((((100vw + 100vh) * 2) / 220) + 15px);

        & * {
          overflow: hidden;
          max-width: 80vw !important;
          font-size: calc((((100vw + 100vh) * 2) / 260) + 5px);
          line-height: calc((((100vw + 100vh) * 2) / 250) + 9px);
        }

        & blockquote {
          padding-left: calc((((100vw + 100vh) * 2) / 220) + 20px) !important;
          font-size: calc((((100vw + 100vh) * 2) / 220) + 6px);
          line-height: calc((((100vw + 100vh) * 2) / 220) + 11px);
          margin: 2% 0px;
        }

        & iframe {
          max-width: 80vw;
          max-width: 100%;
        }

        & h1 {
          font-size: calc((((100vw + 100vh) * 2) / 160) + 6px);
          line-height: calc((((100vw + 100vh) * 2) / 150) + 10px);
          & span {
            font-size: calc((((100vw + 100vh) * 2) / 160) + 6px);
            line-height: calc((((100vw + 100vh) * 2) / 150) + 10px);
          }
        }

        & h2 {
          font-size: calc((((100vw + 100vh) * 2) / 190) + 5px);
          line-height: calc((((100vw + 100vh) * 2) / 180) + 9px);
          & span {
            font-size: calc((((100vw + 100vh) * 2) / 190) + 5px);
            line-height: calc((((100vw + 100vh) * 2) / 180) + 9px);
          }
        }

        & h3 {
          font-size: calc((((100vw + 100vh) * 2) / 220) + 5px);
          line-height: calc((((100vw + 100vh) * 2) / 210) + 9px);
          & span {
            font-size: calc((((100vw + 100vh) * 2) / 220) + 5px);
            line-height: calc((((100vw + 100vh) * 2) / 210) + 9px);
          }
        }

        & h4 {
          font-size: calc((((100vw + 100vh) * 2) / 260) + 5px);
          line-height: calc((((100vw + 100vh) * 2) / 250) + 9px);
          & span {
            font-size: calc((((100vw + 100vh) * 2) / 260) + 5px);
            line-height: calc((((100vw + 100vh) * 2) / 250) + 9px);
          }
        }

        & h6 {
          font-size: calc((((100vw + 100vh) * 2) / 320) + 4px);
          line-height: calc((((100vw + 100vh) * 2) / 320) + 6px);
          & span {
            font-size: calc((((100vw + 100vh) * 2) / 320) + 4px);
            line-height: calc((((100vw + 100vh) * 2) / 320) + 6px);
          }
        }

        & img {
          // border-radius: 5px;
          // min-width: 80vw !important;
          object-fit: cover;
          // max-width: 80vw !important;
          // height: auto !important;
          // max-height: 80vw !important;
        }

        & table {
          overflow: scroll;
          display: block;
        }

        & tr:nth-child(1) {
          & td {
            min-width: 20vw;
            overflow-wrap: break-word;
          }
        }

        & ::-webkit-scrollbar {
          // width: 10px !important
          height: 10px;
        }

        & ::-webkit-scrollbar-track {
          // margin: 12px 0px !important;
        }

        & ::-webkit-scrollbar-thumb {
          border-radius: 20px;
          background: $cor_cinza_medium !important;
          border: 3px solid white !important;
          min-width: 70% !important;
        }

        & ::-webkit-scrollbar-thumb:hover {
          background: $cor_roxo !important;
        }
      }

      & .rodape {
        margin: 15% 0px;

        & .botao-aceito {
          margin-right: 10px;
          padding: 10px 10px;
          font-size: 12px;
          border: 0px;

          &:disabled {
            font-size: 12px;
            line-height: 13px;

            & div {
              margin-left: 8px;
            }

            & img {
              width: 25px;
              height: auto;
            }
          }
        }

        & ul {
          margin-top: 5px;

          & li {
            font-size: 9px;
            margin-bottom: 5px;

            & a {
              padding: 1px 4px;
            }
          }
        }
      }
    }
  }
}

@media all and (min-width: 679px) and (max-width: 1000px) {
  .conteudo-post {
    & .post {
      & /deep/ .postagem {
        * {
          overflow: visible;
        }

        & img {
          // border-radius: 5px;
         //  min-width: unset;
          object-fit: contain;
          // max-width: 80vw !important;
          // height: auto !important;
          // max-height: 80vw !important;
        }

        & tr:nth-child(1) {
          & td {
            min-width: 15vw;
          }
        }

        & ::-webkit-scrollbar {
          // width: 10px !important
          height: 12px;
        }
      }

      & .rodape {
        margin: 15% 0px;
      }
    }
  }
}
</style>
